import Adds from './configure';
import AddsRedundant from './redundant';

const ADDS = [
    Adds,
    AddsRedundant,
];

export default ADDS;